import React from 'react';
import useMainProjects from '@ubeya/shared/hooks/account/useMainProjects';
import { FlexMiddle } from '../../Flex';

const MainEventChip = ({ value }) => {
  const { allMainProjectById } = useMainProjects({ timeRange: undefined });

  return (
    <FlexMiddle>
      {value
        .map((id) => allMainProjectById[id]?.name)
        .filter(Boolean)
        .join(', ')}
    </FlexMiddle>
  );
};

export default MainEventChip;
